import SharedPagination from "@/components/common/Pagination";
import { useSearchContext } from "@/features/search/context/SearchContext";

/**
 * Search's page navigation: the site-wide control, wired to the search query.
 *
 * All this adds is where the numbers come from. `pageInfo` is the search API's own, and
 * `buildHref` keeps the rest of the query string — facets, sort — intact across a page change,
 * which the default `?page=n` builder cannot do.
 */
export const Pagination = () => {
  const { query, navigation } = useSearchContext();
  const info = query.data?.pageInfo;

  if (!info) {
    return null;
  }

  return (
    <SharedPagination
      page={info.page}
      pages={info.pages}
      loading={query.isFetching}
      buildHref={page => navigation.buildHref({ page })}
    />
  );
};
